import React, { useEffect, useRef } from 'react';

const COLORS = ['t-bg-butter', 't-bg-quiz-teal', 't-bg-surface', 't-bg-butter', 't-bg-[#4FB3A9]'];
const PARTICLES = Array.from({ length: 42 }, (_, index) => index);

const RetentionGiftConfetti = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

    const animations = Array.from(containerRef.current.children).flatMap((particle) => {
      if (!particle.animate) return [];
      const angle = Math.random() * Math.PI * 2;
      const distance = 90 + Math.random() * 170;
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance;
      return particle.animate(
        [
          { transform: 'translate(0,0) rotate(0)', opacity: 1 },
          {
            transform: `translate(${x}px,${y - 70}px) rotate(${Math.random() * 540}deg)`,
            opacity: 1,
            offset: 0.55,
          },
          {
            transform: `translate(${x * 1.15}px,${y + 120}px) rotate(${Math.random() * 720}deg)`,
            opacity: 0,
          },
        ],
        { duration: 1400 + Math.random() * 600, easing: 'cubic-bezier(.2,.7,.3,1)' },
      );
    });

    return () => animations.forEach((animation) => animation.cancel());
  }, []);

  return (
    <div
      ref={containerRef}
      aria-hidden="true"
      className="t-pointer-events-none t-absolute t-inset-0 t-z-[9] motion-reduce:t-hidden"
    >
      {PARTICLES.map((index) => (
        <i
          key={index}
          className={`t-absolute t-left-1/2 t-top-1/2 t-h-3 t-w-2 t-rounded-sm t-opacity-0 ${COLORS[index % COLORS.length]}`}
        />
      ))}
    </div>
  );
};

export default RetentionGiftConfetti;
